export default {
  subscribeResourceViGridToFormBuilder: (resourceType, viGridId) => {
    document.querySelector("form-builder-v2").addEventListener("fb-update-resources", (event) => {
      const resourceTypes = event.detail.resourceTypes;
      if (resourceTypes.includes(resourceType)) ViGridHelper.reload(viGridId);
    });
  },
  updateFormBuilderPreviewPages: (formPreviewPages) => {
    const formBuilderEl = document.querySelector("form-builder-v2");
    if (formBuilderEl) {
      formBuilderEl.formBuilderApi.updateFormBuilderPreviewPages(formPreviewPages);
    }
  }
};
